"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BIGINT_SCHEME = exports.STRING_SCHEME = exports.CHARACTER_SCHEME = exports.BOOL_SCHEME = exports.NUMBER_SCHEME = exports.BIGINT_TYPE = exports.STRING_TYPE = exports.CHARACTER_TYPE = exports.BOOL_TYPE = exports.NUMBER_TYPE = void 0;
const type_1 = require("./type");
const builders_1 = require("./builders");
exports.NUMBER_TYPE = {
    kind: type_1.TypeKind.Number,
};
exports.BOOL_TYPE = {
    kind: type_1.TypeKind.Boolean,
};
exports.CHARACTER_TYPE = {
    kind: type_1.TypeKind.Character,
};
exports.STRING_TYPE = builders_1.arrayType(exports.CHARACTER_TYPE);
exports.BIGINT_TYPE = {
    kind: type_1.TypeKind.BigInt,
};
exports.NUMBER_SCHEME = builders_1.unboundScheme(exports.NUMBER_TYPE);
exports.BOOL_SCHEME = builders_1.unboundScheme(exports.BOOL_TYPE);
exports.CHARACTER_SCHEME = builders_1.unboundScheme(exports.CHARACTER_TYPE);
exports.STRING_SCHEME = builders_1.unboundScheme(exports.STRING_TYPE);
exports.BIGINT_SCHEME = builders_1.unboundScheme(exports.BIGINT_TYPE);
//# sourceMappingURL=common.js.map